import React from 'react';
import "../ComponentsCSS/Pricing.css"

const Pricing = () => {
  return (
    <div className="pricing-container my-5" data-aos="zoom-in">
      <h2 className="pricing-title">Pricing</h2>
      <div className="pricing-line-wrapper">
        <div className="pricing-line">
          <div className="dot left-dot" />
          <div className="dot right-dot" />
        </div>
        <div className="labels">
          <span className="label">Long Distance</span>
          <span className="label">Flat Rates</span>
        </div>
      </div>
    </div>
  );
};

export default Pricing;
